// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { DashboardState , initialState } from './state';


export function reducer(state = initialState, action: Actions): DashboardState  {
  switch (action.type) {
    // Task COMMON METHOD
    case ActionTypes.DASHBOARD_COMMON: {
      return state;
    }
    // Task Success COMMON METHOD
    case ActionTypes.DASHBOARD_COMMON_SUCCESS: {
      // commonly store and handle all Task modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }
    // DEFAULT
    default:
      return state;
  }
}
